/**
 * GradientText - Text component with gradient coloring
 *
 * Applies gradient effects to text for visual emphasis. Should only be used on dark backgrounds
 * to maintain WCAG AA contrast requirements.
 */

import { ReactNode } from "react";

interface GradientTextProps {
  children: ReactNode;
  gradient?: "primary" | "accent" | "success" | "danger";
  className?: string;
}

export default function GradientText({
  children,
  gradient = "primary",
  className = "",
}: GradientTextProps) {
  const gradientClasses = {
    primary: "bg-gradient-to-r from-pink-400 to-purple-400",
    accent: "bg-gradient-to-r from-purple-400 to-pink-400",
    success: "bg-gradient-to-r from-green-400 to-emerald-500",
    danger: "bg-gradient-to-r from-red-400 to-orange-500",
  };

  return (
    <span
      className={`
        ${gradientClasses[gradient]}
        bg-clip-text
        text-transparent
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </span>
  );
}
